import React, { useState, useEffect } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import ProfileNavbar from "../Component/ProfileNavbar";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import axios from "axios";
import defaultuser from "../Component/img/user.png"; // Default image if no profile image is available
import { Link } from 'react-router-dom';

const Connection = () => {
  const [randomUsers, setRandomUsers] = useState([]);
  const [userConnections, setUserConnections] = useState({});  // To track connection status
  const [loading, setLoading] = useState({}); // Loading state for each connection
  const user_id = localStorage.getItem("visitor_id"); // Get the visitor ID from localStorage

  useEffect(() => {
    // Fetch random users from the API
    const fetchRandomUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/random-users`, {
          params: { user_id }, // Sending the user_id as a query parameter
        });
  
        if (response.data.randomUsers) {
          setRandomUsers(response.data.randomUsers);
        }
      } catch (error) {
        // Only log the error if the status code is not 409
        if (error.response && error.response.status !== 409) {
          console.error("Error fetching random users:", error);
        }
      }
    };
  
    fetchRandomUsers();
  }, [user_id]);
  

  // Function to handle connection request
  const handleConnect = async (receiver_id) => {
    try {
      // Set the loading state for the specific user
      setLoading((prevLoading) => ({
        ...prevLoading,
        [receiver_id]: true,
      }));
  
      // Prepare the data to send in the POST request
      const connectionData = {
        sender_id: user_id,
        receiver_id: receiver_id,
      };
  
      // Send a POST request to create a connection
      const response = await axios.post(`${BASE_URL}/create-connection`, connectionData);
  
      // Introduce a 2-second delay before processing the response
      await new Promise((resolve) => setTimeout(resolve, 2000));
  
      if (response.data.message) {
        // Handle success, update the connection status for the user
        setUserConnections((prevState) => ({
          ...prevState,
          [receiver_id]: response.data.connection_status, // Update the connection status
        }));
      } else { 
        console.error("Failed to create connection");
      }
    } catch (error) {
      console.error("Error creating connection:", error); 
    } finally {
      // Remove loading state after 2 seconds
      setLoading((prevLoading) => ({
        ...prevLoading,
        [receiver_id]: false,
      }));
    }
  };
  
  

  return (
    <>
      <NavbarVisitor />
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <ProfileNavbar />
            </div>
            <div className="col-md-9">
              <div className="bg-salt mt-3 p-2 py-3 mb-3 text-start">
                <h2 className="text-start hedng">Connections</h2>

                <div className="d-flex p-2">
                    <Link to="/my-connection"><div className="reqbtna reqbtnaActive">Send Request</div></Link>
                    <Link to="/connection-pending"><div className="reqbtna">Pending Request</div></Link>
                </div>

                <div className="row">
                  {randomUsers.length > 0 ? (
                    randomUsers.map((user) => {
                      // Get the connection status and loading status for the user
                      const connectionStatus = userConnections[user.id];
                      const isLoading = loading[user.id];

                      return (
                        <div key={user.id} className="col-md-6 mb-2">
                          <div className="d-flex justify-content-between align-items-center bg-white p-2">
                            <div className="d-flex">
                              <div>
                                <img
                                  src={
                                    user.profile_image
                                      ? `${BASE_URL}/images/${user.profile_image}`
                                      : defaultuser
                                  }
                                  className="img-fluid maxconimg"
                                  alt="Profile"
                                />
                              </div>
                              <div className="ms-3">
                                <div className="oksa">
                                  <strong>{user.name}</strong>
                                </div>
                                <div className="oksa">{user.designation}</div>
                                <div className="oksa">
                                  {user.city}, {user.state}, {user.country}
                                </div>
                              </div>
                            </div>

                            <div className="ms-3">
                              {/* Conditionally render the button based on connection status and loading */}
                              {connectionStatus === "request_sent" ? (
                                <button className="btnflo1 bg-gradient-primary" disabled>
                                  Pending
                                </button>
                              ) : isLoading ? (
                                <button className="btnflo1 bg-gradient-primary" disabled>
                                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  &nbsp;Sending
                                </button>
                              ) : (
                                <button
                                  className="btnflo1 bg-gradient-primary"
                                  onClick={() => handleConnect(user.id)} // Call handleConnect on button click
                                >
                                  Connect
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div>No users found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Connection;